import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { useSearchParams } from 'next/navigation';
import type { SignupQuizContent } from '@galapagos/shared/registration';
import { useSignupApi } from './useSignupApi';

/**
 * The quiz's question content, through the signup data seam. No retry, like
 * the program options: the content is served from the bundle, so a failure
 * would not heal on a second try.
 */
export function useSignupQuizContent(): UseQueryResult<SignupQuizContent> {
  const api = useSignupApi();
  const scenario = useSearchParams().get('scenario');
  // One structure serves every language; the words come from the catalog, so
  // a language switch re-renders the step with its answers kept.
  return useQuery({
    queryKey: ['signup', 'quiz-content', scenario],
    queryFn: () => api.getQuizContent(),
    retry: false,
  });
}
